import { useState } from "react";
import Form from "react-bootstrap/Form";

const monthNames = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"
];

// Reusable component for each reminder
export const ReminderSelector = ({ label, unit, setUnit, value, setValue ,disabled, setDisabled}) => {
  return (
    <Form.Group className="mb-3">
      <Form.Label className="fw-semibold">{label}</Form.Label>

      <div className="d-flex gap-3">

        {/* Dropdown 1 */}
        <Form.Select
          value={unit}
          onChange={(e) => setUnit(e.target.value)}
          disabled={!disabled}
          style={{ maxWidth: "150px" }}
        >
          <option value="">Select Unit</option>
          <option value="2">Days</option>
          <option value="1">Hours</option>
          <option value="0">Minutes</option>
          {/* <option value="Weeks">Weeks</option> */}
          {/* <option value="Months">Months</option> */}
        </Form.Select>

        {/* Dropdown 2 */}
        <Form.Select
          value={value}
          onChange={(e) => setValue(e.target.value)}
          disabled={!disabled}
          style={{ maxWidth: "150px" }}
        >
          <option value="">Select Value</option>
          {/* Days (1–31) */}
          {unit === "2" &&
            [...Array(31)].map((_, i) => (
              <option key={i} value={i + 1}>{i + 1}</option>
            ))}

          {/* Hours (0–23) */}
          {unit === "1" &&
            [...Array(24)].map((_, i) => (
              <option key={i} value={i}>{i}</option>
            ))}

          {/* Minutes (0–59) */}
          {unit === "0" &&
            [...Array(60)].map((_, i) => (
              <option key={i} value={i}>{i}</option>
            ))}

          {/* Weeks (1–52) */}
          {unit === "Weeks" &&
            [...Array(52)].map((_, i) => (
              <option key={i} value={i + 1}>{i + 1}</option>
            ))}

          {/* Months (names) */}
          {unit === "Months" &&
            monthNames.map((month, index) => (
              <option key={index} value={month}>{month}</option>
            ))}

        </Form.Select>
        <Form.Check
          type="switch"
          label="Disable"
          checked={disabled}
          onChange={(e) => setDisabled(e.target.checked)}
        />
      </div>
    </Form.Group>
  );
};
